import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { TradeIn } from "Types/TradeIn";
import { TradeIn as CcdpTradeIn } from "@carsdotcom/ccdp-sdk/lib/es6/domains/trade-in";
import { VehicleState } from "Types/state";

export const toggleTradeInDrawer = actionCreator("trade_in/drawer/toggle");

export const toggleTradeInEstimateModeManual = actionCreator("trade_in/toggle_estimate_mode/manual");

export const toggleTradeInEstimateModeTradePending = actionCreator("trade_in/toggle_estimate_mode/trade_pending");

export const toggleTradeInVehicleModeDefault = actionCreator("trade_in/toggle_vehicle_mode/default");

export const toggleTradeInVehicleModeFallback = actionCreator("trade_in/toggle_vehicle_mode/fallback");

export const patchTradeInRequest = actionCreator(
    "trade_in/patch/request",
    (
        tradeIn: TradeIn,
        uuid: string,
        eventName?: "start_trade_in" | "finish_trade_in",
        eventTradeInType?: "manual" | "trade_pending"
    ) => ({
        tradeIn,
        uuid,
    }),
    (
        tradeIn: TradeIn,
        uuid: string,
        eventName?: "start_trade_in" | "finish_trade_in",
        eventTradeInType?: "manual" | "trade_pending"
    ) => ({
        route: API.TradeIn,
        analytics: { eventName, eventTradeInType },
    })
);

export const patchTradeInSuccess = actionCreator("trade_in/patch/success", (tradeIn: TradeIn) => ({ tradeIn }));

export const patchTradeInFailure = actionCreator("trade_in/patch/failure");

export const deleteTradeInRequest = actionCreator(
    "trade_in/delete/request",
    (uuid: string, reset: boolean = false) => ({ uuid, reset }),
    () => ({ route: API.TradeIn })
);

export const deleteTradeInSuccess = actionCreator("trade_in/delete/success");

export const deleteTradeInFailure = actionCreator("trade_in/delete/failure");

export const getTradePendingDetailsRequest = actionCreator(
    "trade_pending_details/get/request",
    (
        details: {
            answers: {
                body?: string;
                doors?: string;
                drivetrain?: string;
                engine?: string;
                fuel_type?: string;
            };
            ymmt?: string;
            make?: string;
            model?: string;
            trim?: string;
            year?: string;
            partner_id: string;
        },
        uuid: string,
        shouldPatch: boolean = false
    ) => ({
        details,
        uuid,
        shouldPatch,
    }),
    () => ({ route: API.TradeIn })
);

export const getTradePendingDetailsSuccess = actionCreator(
    "trade_pending_details/get/success",
    (choices: string[], question: "body" | "doors" | "drivetrain" | "engine" | "fuel_type", id: string) => ({
        choices,
        question,
        id,
    })
);

export const getTradePendingDetailsFailure = actionCreator("trade_pending_details/get/failure");

export const getAndPatchTradePendingReportRequest = actionCreator(
    "trade_pending_report/get+patch/request",
    ({
        ...payload
    }: { postalCode: string; partnerId: string; url: string | null; uuid: string; vehiclesForFEA: VehicleState[] } & (
        | // discriminated union type due to difference between our schema and CCDP
        {
              tradeIn: Pick<Required<TradeIn>, "id"> & { miles: number };
              initiator: "user";
          }
        | {
              tradeIn: Pick<CcdpTradeIn, "id" | "miles" | "condition">;
              initiator: "ccdp";
          }
    )) => ({
        ...payload,
    }),
    () => ({ route: API.TradeIn })
);

export const getAndPatchTradePendingReportSuccess = actionCreator(
    "trade_pending_report/get+patch/success",
    (tradeIn: TradeIn) => ({
        tradeIn,
    })
);

export const getAndPatchTradePendingReportFailure = actionCreator(
    "trade_pending_report/get+patch/failure",
    (error?: string) => ({
        error,
    })
);
